import { SupplierComputedProduct } from "../../types/supplierComputedProduct";

export function findSupplierComputedProductByLinkProduct(linkProductIds : string[], supplierComputedProducts : SupplierComputedProduct[]) : SupplierComputedProduct[] | undefined {
    return supplierComputedProducts.filter((product) => product.linkProductId && linkProductIds.includes(product.linkProductId));
}